import { useState } from "react";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import PropTypes from "prop-types";
import { Radio, RadioGroup } from "@components/Radio";
import { Button } from "@components/Button";
import { formatSize, handleize } from "@lib/formatString";
import styles from "./styles/swatch.module.css";

const EXCLUDE_LIST = ["gid://shopify/Product/6925491830867", "gid://shopify/Product/6925491798099"];

const Swatch = ({
  heading,
  data,
  name,
  handle,
  previewOnHover,
  updateVariant,
  hidden,
  openSizeGuide,
  product,
}) => {
  const { t } = useTranslation("productpage");

  // use to keep track of what the color is on hover
  // in order to temporarily display the color when
  // a user hovers over one of the non selected colors
  const [titleOnHover, setTitleOnHover] = useState(null);
  const selected = data?.find((datum) => datum.selected);

  const router = useRouter();

  const onMouseEnter = (event) => {
    const value = event.target.getAttribute("data-label");
    const id = event.target.getAttribute("id");

    const blah = data?.find((datum) => datum.id === id);

    if (previewOnHover && blah) {
      //previewOnHover(blah);
    }
    setTitleOnHover(value);
  };
  const onMouseLeave = (event) => {
    const id = event.target.getAttribute("id");
    const blah = data?.find((datum) => datum.id === id);

    setTitleOnHover(null);
    if (previewOnHover) {
      //previewOnHover(selected ? selected : blah);
    }
  };

  const onClick = (selectedValue) => {
    const query = {
      ...router.query,
      [handleize(handle.toLowerCase())]: handleize(selectedValue.value),
    };

    router.replace(
      {
        pathname: "/products/[slug]",
        query: query,
      },
      undefined,
      { shallow: true }
    );

    if (updateVariant) {
      updateVariant(selectedValue);
    }
  };
  const containerStyles = `${styles.container} ${hidden ? styles.hidden : ""}`;

  return (
    <div className={containerStyles}>
      <header className={styles.header}>
        <h4>
          <span className={styles.title}>{t(heading)}</span>
          {titleOnHover ? formatSize(titleOnHover) : t(formatSize(selected?.labelText))}
        </h4>
        {openSizeGuide && !EXCLUDE_LIST.includes(product?.productReferenceV2?.id) && (
          <Button
            variant="tertiary"
            handleClick={openSizeGuide}
            description="Size Guide"
            descriptionText="Click to open Size Guide"
          >
            {t("size-guide-button")}
          </Button>
        )}
      </header>

      <RadioGroup onClickRadioButton={onClick} selectedValue={selected?.value} name={name}>
        {data
          ?.filter((option) => !option.archived)
          .map((datum) => {
            return (
              <Radio
                {...datum}
                labelText={t(datum.labelText)}
                key={`${datum.id}-${handle}`}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
              />
            );
          })}
      </RadioGroup>
    </div>
  );
};

Swatch.defaultProps = {
  heading: "Heading Title",
};

Swatch.propTypes = {
  /** the heading of the swatch used as the title*/
  heading: PropTypes.string.isRequired,
  /**
   * The name of the swatch uses for that radio group
   */
  name: PropTypes.string.isRequired,
  /** Data used to construct the radio buttons values with */
  data: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      labelText: PropTypes.string,
      fill: PropTypes.string,
    }).isRequired
  ).isRequired,
};

export default Swatch;
